import {
  getCompanyByUserId,
  useAuthStore,
  useCommonStore,
} from "@enos-monorepo/lib";
import { useQuery } from "@tanstack/react-query";

export function useCompany() {
  const { user } = useAuthStore();
  const { company } = useCommonStore();
  const { data, ...rest } = useQuery({
    queryKey: ["userCompany", user?.id],
    queryFn: () => getCompanyByUserId(user?.id ?? ""),
    enabled: !!user && user.role !== "SuperAdmin",
  });

  if (user?.role === "SuperAdmin") {
    return { company, ...rest, isPending: false };
  }

  return { company: data, ...rest };
}
